module.exports = __webpack_public_path__ + "static/media/ic-searchd-engine@2x.3b02c3e1.png";